import { render } from "./pageHead.vue?vue&type=template&id=bb7e2860"
import script from "./pageHead.vue?vue&type=script&lang=js"
export * from "./pageHead.vue?vue&type=script&lang=js"

import exportComponent from "/home/king/git/miniapp/northland-bio-miniapp-webclient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__